<template>
  <div class="corps-modal-liste-faces">
    <v-client-table
      ref="tableFacesReseauTempo"
      @filter="onFilterChange"
      :data="dispoFiltre"
      :columns="columns"
      :options="options"
      class="fixed_faceReseau_header">
      <div slot="selected" slot-scope="props" style="text-align:center">
        <input
          v-model="props.row.selected" @click="ajoutFaceSelect(props.row)"
          :value="props.row"
          :disabled="disabled || props.row.dispo === 1"
          type="checkbox"
          id="checkbox">
      </div>
      <div slot="dispo" slot-scope="props" class="is-flex is-justify-content-center">
        <b-tooltip
          :label="props.row.messageIndisponibilite"
          :active="!!props.row.messageIndisponibilite"
          position="is-right"
          multiline>
          <div
            class="image is-24x24 button noHandCursor"
            :class="props.row.dispoClass">
          </div>
        </b-tooltip>
      </div>
      <div slot="filter__selected">
        <b-select v-model="filtreSelected" expanded>
          <option :value="null"> Tout </option>
          <option :value="true"> Oui </option>
          <option :value="false"> Non </option>
        </b-select>
      </div>
      <div slot="filter__dispo">
        <b-select v-model="filtreDispo">
          <option
            v-for="filtre in listeFiltres"
            :value="filtre.value"
            :key="filtre.libelle">
            {{ filtre.libelle }}
          </option>
        </b-select>
      </div>
      <div slot="adresseCommercialeLibelle" slot-scope="props">
        <p class="has-text-default is-size-14px">{{ getLibelleAdresse(props.row) }}</p>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import * as types from '@/store/creationOpportunite/panier-mutation-type';
import {
  DISPONIBLE,
  NON_DISPONIBLE,
} from '@/components/creationOpportunite/configuration/DisponibiliteConf';

const Panier = createNamespacedHelpers('panier');
const Parametrages = createNamespacedHelpers('parametrage');
const user = createNamespacedHelpers('user');

export default {
  name: 'liste-faces-reseau-tempo',
  props: ['reseau', 'disabled', 'generateMarker', 'noUpdate'],
  data() {
    return {
      trad: {
        panCode: '↑↓ Panneau',
        facCode: '↑↓ Face',
        materiel: '↑↓ Materiel',
        format: '↑↓ Format',
        adresseCommercialeLibelle: 'Adresse',
        codePostal: '↑↓ Code postal',
        ville: '↑↓ Ville',
        depCode: '↑↓ Dpt',
        latitude: 'Latitude',
        longitude: 'Longitude',
        dispo: 'Dispo',
        restrictions: '↑↓ Restrictions',
        disposition: '↑↓ Disposition',
        longueur: 'Largeur',
        largeur: 'Hauteur',
        selected: '',
      },
      selectAllValue: true,
      listeFiltres: [
        { libelle: 'Tout', value: null },
        { libelle: 'Disponible', value: DISPONIBLE },
        { libelle: 'Indisponible', value: NON_DISPONIBLE },
      ],
      filtreDispo: null,
      filtreSelected: null,
    };
  },
  computed: {
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
    ...user.mapGetters({
      site: 'site',
    }),
    columns() {
      const list = ['selected', 'dispo', 'panCode', 'facCode', 'materiel', 'format', 'restrictions', 'disposition', 'ville', 'adresseCommercialeLibelle', 'codePostal', 'depCode', 'latitude', 'longitude'];
      if (this.site === 'sopa') {
        list.push('longueur');
        list.push('largeur');
      }
      if (this.noUpdate) list.shift();
      return list;
    },
    iconSelectTotal() {
      if (this.faceIsSelect) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      const that = this;
      return {
        headings: {
          panCode: this.trad.panCode,
          facCode: this.trad.facCode,
          materiel: this.trad.materiel,
          format: this.trad.format,
          restrictions: this.trad.restrictions,
          disposition: this.trad.disposition,
          adresseCommercialeLibelle: this.trad.adresseCommercialeLibelle,
          codePostal: this.trad.codePostal,
          ville: this.trad.ville,
          depCode: this.trad.depCode,
          latitude: this.trad.latitude,
          longitude: this.trad.longitude,
          longueur: this.trad.longueur,
          largeur: this.trad.largeur,
          selected: (h) => {
            if (that.noUpdate) return '';
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
          dispo: this.trad.dispo,
        },
        filterByColumn: true,
        listColumns: {
          dispo: [{
            id: 3,
            text: 'Disponible',
          },
          {
            id: 1,
            text: 'Indisponible',
          }],
        },
        initFilters: {
          dispo: '',
        },
        filterable: ['panCode', 'facCode', 'materiel', 'format', 'restrictions', 'codePostal', 'ville', 'depCode'],
        sortable: ['dispo', 'panCode', 'facCode', 'materiel', 'format', 'restrictions', 'codePostal', 'ville', 'depCode'],
        perPageValues: PER_PAGE_VALUE,
        perPage: 9999999999,
        resizableColumns: true,
        texts: TEXTS,
        columnsClasses: {
          dispo: 'colonneDispo',
          ville: 'ellipsis',
          materiel: 'ellipsis',
          adresseCommercialeLibelle: 'faceReseauTempoTailleColonneAdresse',
          format: 'ellipsis colonneFormat',
          facCode: 'ellipsis',
          panCode: 'ellipsis colonnePanCode',
          codePostal: 'ellipsis faceReseauTempoTailleColonneCodePostal',
          depCode: 'ellipsis faceReseauTempoTailleColonneDpt',
          latitude: 'ellipsis',
          longitude: 'ellipsis',
        },
      };
    },
    dispoFiltre() {
      let listeFaces = this.reseau.listeFaces;
      const filtreDispo = this.listeFiltres.find(el => el.value === this.filtreDispo);
      if (filtreDispo && filtreDispo.value !== null) {
        listeFaces = listeFaces.filter(el => el.dispo === filtreDispo.value);
      }
      if (this.filtreSelected !== null) {
        listeFaces = listeFaces.filter(el => el.selected === this.filtreSelected);
      }
      return listeFaces;
    },
    faceIsSelect() {
      return this.reseau.listeFaces.map(el => el.selected).includes(true);
    },
  },
  methods: {
    ...Panier.mapMutations({
      setReseauxTempoPanier: types.SET_PRODUIT_TYPE_RESEAU_TEMPO,
    }),
    ajoutFaceSelect(faceSelec) {
      const face = this.reseau.listeFaces.find((el) => {
        return faceSelec.facNum === el.facNum;
      });
      face.selected = !face.selected;
      this.generateMarker();
    },
    selectAll() {
      const facesNum = this.$refs.tableFacesReseauTempo.allFilteredData.map((el) => el.facNum);
      this.reseau.listeFaces.filter((el) => {
        return facesNum.includes(el.facNum);
      }).forEach((el) => {
        if (el.dispo === 1) {
          el.selected = false;
        } else {
          el.selected = this.selectAllValue;
        }
      });
      this.selectAllValue = !this.selectAllValue;
      this.setReseauxTempoPanier({
        semaine: this.reseau.extensionOpportunite.semaine,
        annee: this.reseau.extensionOpportunite.annee,
        num: this.reseau.num,
        faces: this.reseau.listeFaces,
      });
      this.generateMarker();
    },
    onFilterChange() {
      this.selectAllValue = true;
    },
    getLibelleAdresse(face) {
      let adresse = '';
      if (face.adresseCommercialeLibelle1 !== null && face.adresseCommercialeLibelle1) {
        adresse += ' ' + face.adresseCommercialeLibelle1;
      }
      if (face.adresseCommercialeLibelle2 !== null && face.adresseCommercialeLibelle2) {
        adresse += ' ' + face.adresseCommercialeLibelle2;
      }
      if (face.adresseCommercialeLibelle3 !== null && face.adresseCommercialeLibelle3) {
        adresse += ' ' + face.adresseCommercialeLibelle3;
      }
      return adresse.trim();
    },
  },
  mounted() {
    this.reseau.listeFaces.sort((a, b) => {
      if (a.ville < b.ville) return -1;
      if (a.ville > b.ville) return 1;
      return 0;
    });
    if (this.reseau.listeFaces.every(el => !el.selected)) this.selectAll();
    this.reseau.listeFaces.forEach((el) => {
      if (el.dispo === 1) el.selected = false;
    });
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo/consultation/listeFacesReseauTempo.vue